<template>
  <div class="separator" />
</template>

<style lang="scss" scoped>
.separator {
  border-top: 1.4px solid var(--clr-s6);
}
</style>
